import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(theme => ({
  progress: {
    margin: theme.spacing(2),
  },
}));

const Loader = React.forwardRef((props, ref) => {
  const classes = useStyles();
  return (
    <Box display="flex" justifyContent="center" p={5}>
      <CircularProgress className={classes.progress} />
    </Box>
  );
});

export default Loader;